/* =====================================================================
   lp-base.js — behaviour for the Ikigai landing-page (lp-) system
   1. Swatch rows: tapping a swatch shows its colour name.
   2. Day counters: "1,785 days and counting" stays current.
   3. Sticky bar: smart show/hide.
   4. Tracking: every [data-lp-cta] click is pushed to the dataLayer
      (GTM) with the test labels from the LP · Page config section.
   Safe to load more than once.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__lpBaseLoaded) return;
  window.__lpBaseLoaded = true;

  var meta = function () { return window.lpMeta || {}; };
  window.dataLayer = window.dataLayer || [];

  function push(event, extra) {
    var payload = { event: event };
    var m = meta();
    for (var k in m) if (Object.prototype.hasOwnProperty.call(m, k)) payload[k] = m[k];
    for (var j in extra) if (Object.prototype.hasOwnProperty.call(extra, j)) payload[j] = extra[j];
    window.dataLayer.push(payload);
  }

  function initSwatches(root) {
    (root || document).querySelectorAll('[data-lp-swatches]').forEach(function (group) {
      if (group.__lpInit) return;
      group.__lpInit = true;
      var label = group.querySelector('[data-lp-swatch-label]');
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lp-swatch]');
        if (!btn) return;
        group.querySelectorAll('[data-lp-swatch]').forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        if (label) label.textContent = btn.getAttribute('data-lp-swatch');
        push('lp_swatch_tap', { lp_swatch: btn.getAttribute('data-lp-swatch') });
      });
    });
  }

  function initDayCounters(root) {
    (root || document).querySelectorAll('[data-lp-days-since]').forEach(function (el) {
      var parts = (el.getAttribute('data-lp-days-since') || '').split('-');
      if (parts.length !== 3) return;
      var start = new Date(+parts[0], +parts[1] - 1, +parts[2]);
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var days = Math.round((today - start) / 86400000);
      if (!(days > 0)) return;
      var num = el.querySelector('[data-lp-days-number]');
      if (num) num.textContent = days.toLocaleString('en-US');
    });
  }

  /* Sticky bar. "smart": show once the first lp section (hero) has
     scrolled away, hide while the case picker (#cases) is on screen,
     since every card there has its own button. */
  function initSticky() {
    var bar = document.querySelector('.lp-sticky');
    if (!bar) return;
    document.body.classList.add('lp-has-sticky');
    if (bar.__lpInit) return;
    bar.__lpInit = true;
    /* Shopify's preview bar (preview links only, never real visitors)
       sits at the bottom of the screen; lift the bar above it. */
    var pbar = document.getElementById('PBarNextFrameWrapper');
    if (pbar && pbar.offsetHeight) bar.style.setProperty('--lp-sticky-lift', pbar.offsetHeight + 'px');
    if (bar.getAttribute('data-lp-sticky') !== 'smart' || !('IntersectionObserver' in window)) {
      bar.classList.add('is-on');
      return;
    }
    var hero = document.querySelector('.lp-section');
    var picker = document.getElementById('cases');
    var pastHero = !hero, overPicker = false;
    function update() { bar.classList.toggle('is-on', pastHero && !overPicker); }
    if (hero) new IntersectionObserver(function (es) {
      es.forEach(function (e) { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; });
      update();
    }).observe(hero);
    if (picker) new IntersectionObserver(function (es) {
      es.forEach(function (e) { overPicker = e.isIntersecting; });
      update();
    }, { rootMargin: '0px 0px -25% 0px' }).observe(picker);
    update();
  }

  /* In-page jumps (#cases etc.): land below the theme's sticky header.
     The header (#header) turns fixed once the page is scrolled, so the
     offset is measured at click time, not hard-coded. */
  function headerOffset() {
    var h = document.getElementById('header');
    var height = h ? h.getBoundingClientRect().height : 0;
    return Math.round(height);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || !a.closest('.lp')) return;
    var id = a.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  document.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-lp-cta]');
    if (!cta) return;
    push('lp_cta_click', {
      lp_cta: cta.getAttribute('data-lp-cta'),
      lp_cta_label: (cta.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
      lp_cta_href: cta.getAttribute('href') || ''
    });
  });

  function init(root) {
    initSwatches(root);
    initDayCounters(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  /* Theme editor: re-run when a section is added or edited. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
